module.exports = __webpack_public_path__ + "img/diligence_footer.41c610ad.png";